<template>
	<div class="import">
		<h3></h3>
		<label class="csv-reader">
			<input type="file" @change="loadTextFromFile" />
		</label>

		<h1 v-if="promotionID">{{ promotionID }}</h1>

		<div class="importWrapper">
			<input name="name" class="textInput" placeholder="Discount Name" v-model="name" />

			<br />

			<input name="discountPrefix" class="textInput" :value="prefix" disabled />

			<br />

			<div class="shops">
				<h3>Shops</h3>

				<div class="shopsWrapper">
					<a @click="selectAllShops">Select All Shops</a>
					<div v-for="(data, index) of shops" v-bind:key="index">
						<b-checkbox class="checkbox" v-model="selectedShops" :native-value="data._id">{{ data.name }}</b-checkbox>
					</div>
				</div>
			</div>

			<div class="datepickerWrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today"></b-datepicker>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
					></b-datepicker>
				</b-field>
			</div>

			<div v-if="content.length > 0" class="dataWrapper">
				<div v-for="(data, index) of content" v-bind:key="index" class="importData">
					<div>{{ data.brand }}</div>
					<div>{{ brands[index].name }}</div>
					<div>{{ data.percentage }}%</div>
				</div>
			</div>

			<div @click="submit">Save</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'import',
	data: () => ({
		name: null,
		prefix: 'PPB',
		startingDate: null,
		endingDate: null,
		minDate: null,
		content: [],
		raw: '',
		shops: null,
		selectedShops: [],
		brands: [],
		promotions: [],
		promotionID: null
	}),
	mounted: function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		this.getShops()
	},
	watch: {
		startingDate: function(data) {
			this.minDate = data
		},

		content: function() {
			this.verifyContent()
		}
	},
	methods: {
		// Push to API
		submit: async function() {
			// Make sure there are required fields
			if (this.name == null || this.startingDate == null || this.endingDate == null || this.selectedShops.length < 1) {
				this.$buefy.toast.open({
					duration: 1000,
					message: 'Missing required fields',
					type: 'is-danger',
					position: 'is-top'
				})

				return
			}
			var data = {}
			var shops = []

			this.selectedShops.map(shop => {
				shops.push(shop)
			})

			data.name = this.name
			data.prefix = this.prefix
			data.shops = shops
			data.promotions = []

			// console.log(this.$moment(this.startingDate).format('x'))

			this.promotions.map(promotion => {
				promotion.condition.date.from = this.$moment(this.startingDate).format('x')
				promotion.condition.date.to = this.$moment(this.endingDate).format('x')

				data.promotions.push(promotion)
			})

			const apiSubmit = await this.$api.submit({ data })

			if (apiSubmit == undefined) {
				this.$buefy.toast.open({
					duration: 1000,
					message: 'Error!',
					type: 'is-danger',
					position: 'is-top'
				})

				return
			}

			this.promotionID = apiSubmit.data.code
			// console.log(apiSubmit)

			this.name = null
			this.startingDate = null
			this.endingDate = null
			;(this.content = []), (this.selectedShops = [])
			this.brands = []
			this.promotions = []
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Select all shops
		selectAllShops: function() {
			this.selectedShops = []

			this.shops.map(data => {
				this.selectedShops.push(data._id)
			})
		},

		// Verify if the brand ID and values are valid
		verifyContent: async function() {
			this.content.map(async csvContent => {
				var data = {
					code: csvContent.brand
				}

				const apiGetBrand = await this.$api.getBrand({ data })

				if (apiGetBrand == undefined || apiGetBrand.data.list.total > 1) {
					this.$buefy.toast.open({
						duration: 1000,
						message: csvContent.brand + ' Not Found!',
						type: 'is-danger',
						position: 'is-top'
					})

					return
				}

				var promotion = {}
				var brands = []

				// Set Brand ID
				brands.push(apiGetBrand.data.list[0]._id)

				var brandData = {
					id: apiGetBrand.data.list[0]._id,
					name: apiGetBrand.data.list[0].name
				}

				this.brands.push(brandData)

				promotion.type = 'discount_product_percentage_by_brands'

				promotion.condition = {
					percentage: csvContent.percentage,
					brands,
					date: {}
				}

				this.promotions.push(promotion)
			})
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				// Loop every row to put it in array
				raw.map(data => {
					var splitData = data.split(/,/)

					var newData = {}

					newData.brand = splitData[0]
					newData.percentage = splitData[1]

					this.content.push(newData)
				})
			}

			reader.readAsText(file)
		}
	}
}
</script>

<style scoped>
@import '../styles/Import.css';
</style>
